// Arabic strings for the settings stream (installation settings, PD-710; PD-665 – PD-689) —
// DEVELOPMENT DRAFT by Claude (PD-011); unreviewed until decision H-10.
import type { enSettings } from './en-settings.ts';
import type { Message } from './types.ts';

export const arSettings: { readonly [K in keyof typeof enSettings]: Message } = {
  // ------------------------------------------------------------ page
  'set.nav': 'إعدادات التثبيت',
  'set.title': 'إعدادات التثبيت',
  'set.intro': 'الحدود والمهل الزمنية والجداول ومفاتيح المزوّدين لهذا التثبيت. تُطبَّق التغييرات دون إعادة تشغيل: فورًا في هذه العملية، وخلال ثانية في غيرها. يُسجَّل كل تغيير في سجل تدقيق المنصة.',
  'set.loadingFailed': 'تعذّر تحميل إعدادات التثبيت.',
  'set.version': 'إصدار الإعدادات {version}',
  'set.filter': 'عرض',
  'set.filter.all': 'كل الإعدادات',
  'set.filter.changed': 'المختلفة عن القيمة الافتراضية',
  // ------------------------------------------------------------ groups
  'set.g.security': 'الأمان وتسجيل الدخول',
  'set.g.email': 'البريد والرسائل',
  'set.g.integrations': 'التكاملات',
  'set.g.malware': 'فحص البرمجيات الضارة',
  'set.g.ai': 'إضافات الذكاء الاصطناعي',
  'set.g.worker': 'العامل والمهام الخلفية',
  'set.g.rateLimits': 'حدود المعدّل',
  'set.g.exports': 'التصدير والاستيراد والتقارير',
  'set.g.devices': 'الأجهزة',
  // ------------------------------------------------------------ one setting
  'set.default': 'الافتراضي: {value}',
  'set.isDefault': 'افتراضي',
  'set.changed': 'معدّل',
  'set.source.console': 'مضبوط في وحدة التحكم',
  'set.source.environment': 'مستورد مرة واحدة من البيئة',
  'set.source.default': 'القيمة الافتراضية المضمّنة',
  'set.updated': 'آخر تغيير {at} بواسطة {by}',
  'set.updatedSystem': 'آخر تغيير {at} (استيراد من البيئة)',
  'set.updatedAt': 'آخر تغيير {at}',
  'set.replaces': 'يحلّ محل متغير البيئة {name}',
  'set.usedBy.api': 'تستخدمه الواجهة البرمجية',
  'set.usedBy.worker': 'يستخدمه العامل',
  'set.usedBy.both': 'تستخدمه الواجهة البرمجية والعامل',
  'set.sensitive': 'حساس: يتطلب سببًا وتأكيدًا',
  'set.save': 'حفظ',
  'set.saved': 'تم الحفظ. القيمة الجديدة سارية.',
  'set.reset': 'إعادة إلى الافتراضي',
  'set.resetDone': 'تمت الإعادة. القيمة الافتراضية سارية.',
  'set.storedProblem': 'القيمة المخزّنة غير سارية هنا ({problem})؛ تُطبَّق القيمة الافتراضية إلى أن تُغيَّر.',
  'set.on': 'مفعّل',
  'set.off': 'متوقف',
  'set.none': 'غير مضبوط',
  'set.secret.set': 'يوجد مفتاح مخزّن (لا يُعرض أبدًا).',
  'set.secret.notSet': 'لا يوجد مفتاح مخزّن.',
  'set.secret.new': 'قيمة جديدة',
  'set.secret.replace': 'تخزين المفتاح',
  'set.secret.clear': 'إزالة المفتاح المخزّن',
  'set.secret.help': 'للكتابة فقط: تُختم القيمة بحلقة مفاتيح الهوية ولا يمكن قراءتها مجددًا، ولا حتى من قِبل مسؤولي النظام.',
  'set.conflict': 'غيّر شخص آخر هذا الإعداد. تعرض الصفحة الآن القيمة الحالية؛ راجعها وحاول مرة أخرى.',
  // ------------------------------------------------------------ confirmation dialog
  'set.confirm.title': 'تغيير {label}؟',
  'set.confirm.body': 'يؤثر هذا الإعداد في الأمان أو فيما يمكن للتثبيت الوصول إليه. يُطبَّق التغيير فورًا على كل المؤسسات ويُسجَّل مع السبب الذي تذكره.',
  'set.confirm.from': 'الحالي: {value}',
  'set.confirm.to': 'الجديد: {value}',
  'set.confirm.reason': 'السبب',
  'set.confirm.check': 'أفهم عاقبة هذا التغيير.',
  'set.confirm.apply': 'تطبيق التغيير',
  // ------------------------------------------------------------ units
  'set.unit.ms': 'ملّي ثانية',
  'set.unit.seconds': 'ثانية',
  'set.unit.hours': 'ساعة',
  'set.unit.days': 'يوم',
  'set.unit.bytes': 'بايت',
  'set.unit.kib': 'كيلوبايت',
  'set.unit.perMinute': 'في الدقيقة',
  'set.range': 'المسموح: {min} – {max}',
  'set.productionMin': '{min} على الأقل في بيئة الإنتاج',
  // ------------------------------------------------------------ option labels
  'set.o.none': 'لا شيء',
  'set.o.local': 'صندوق صادر محلي للتطوير',
  'set.o.simulator': 'محاكي (للتطوير فقط)',
  'set.o.clamav': 'ClamAV',
  'set.o.low': 'منخفض',
  'set.o.medium': 'متوسط',
  'set.o.high': 'مرتفع',
  'set.o.local-rules': 'قواعد محلية (دون اتصال)',
  'set.o.anthropic': 'Anthropic (خارجي)',
  // ------------------------------------------------------------ problems and validation
  'set.p.productionMinimum': 'أقل من الحد الأدنى للإنتاج وهو {min}.',
  'set.p.simulatorProduction': 'المحاكيات غير مسموح بها في بيئة الإنتاج.',
  'set.p.localOutboxProduction': 'الصندوق الصادر المحلي للتطوير غير مسموح به في بيئة الإنتاج.',
  'set.p.clamavNotWired': 'ClamAV غير موصول في هذا النشر (المتغير CLAMAV_HOST غير مضبوط).',
  'set.p.wrongKeyRing': 'خُتم السر المخزّن بحلقة مفاتيح أخرى.',
  'set.p.keyRingMissing': 'حلقة المفاتيح الخاصة بهذا السر غير متاحة.',
  'set.v.modelId': 'أدخل معرّف نموذج مثل claude-opus-5-5.',
  'set.v.secretLength': 'أدخل ما بين 10 و500 حرف.',
  'set.v.reasonRequired': 'اذكر سببًا لهذا التغيير.',
  'set.v.confirmRequired': 'أكّد أنك تفهم عاقبة التغيير.',
  'set.v.hostnameGuard': 'اسم المضيف هذا غير مسموح به في ملف النشر هذا.',
  // ------------------------------------------------------------ environment facts (read only)
  'set.env.title': 'من البيئة',
  'set.env.intro': 'تبقى هذه في بيئة النشر (اتصالات قاعدة البيانات وحلقات المفاتيح والشبكة وتوصيل الخدمات). تُعرض للقراءة فقط لتعرف ما الذي ما زال يأتي من هناك.',
  'set.env.profile': 'ملف النشر',
  'set.env.nodeEnv': 'وضع العملية',
  'set.env.version': 'الإصدار',
  'set.env.consoleHosts': 'أسماء مضيف وحدة التحكم',
  'set.env.scheme': 'البروتوكول والمنفذ العامّان',
  'set.env.defaultPort': 'المنفذ الافتراضي',
  'set.env.origins': 'المصادر المقبولة (مشتقة من نطاقات المؤسسات)',
  'set.env.excluded': 'مستبعد بقواعد أسماء المضيفين: {hostname} — {reason}',
  'set.env.clamav': 'خدمة ClamAV موصولة',
  'set.env.keyRing': 'حلقة مفاتيح الهوية للإعدادات المختومة',
  'set.env.yes': 'نعم',
  'set.env.no': 'لا',
  'set.env.ignored': 'متغيرات منقولة ما زالت في البيئة (مُتجاهلة)',
  'set.env.retired': 'متغيرات متقاعدة ما زالت في البيئة (لا تُقرأ أبدًا)',
  'set.env.noneListed': 'لا شيء',
  // ------------------------------------------------------------ settings (label / help)
  'set.k.password.hashMemoryKiB.label': 'ذاكرة تجزئة كلمات المرور',
  'set.k.password.hashMemoryKiB.help': 'كلفة الذاكرة في argon2id لتجزئات كلمات المرور الجديدة. تحتفظ التجزئات الحالية بمعاملاتها وتُحدَّث عند تسجيل الدخول التالي.',
  'set.k.password.hashPasses.label': 'دورات تجزئة كلمات المرور',
  'set.k.password.hashPasses.help': 'كلفة الوقت (عدد الدورات) في argon2id لتجزئات كلمات المرور الجديدة.',
  'set.k.password.hashParallelism.label': 'توازي تجزئة كلمات المرور',
  'set.k.password.hashParallelism.help': 'عدد المسارات في argon2id لتجزئات كلمات المرور الجديدة.',
  'set.k.verification.simulators.label': 'محاكيات التحقق من الهوية',
  'set.k.verification.simulators.help': 'محاكيات محلية لـ UAE PASS وقارئ الهوية الإماراتية ومسح المستندات. للتطوير فقط؛ لا تُستخدم أبدًا في الإنتاج.',
  'set.k.mail.smtpTimeoutMs.label': 'مهلة SMTP',
  'set.k.mail.smtpTimeoutMs.help': 'حدّ الاتصال والترحيب وكل أمر. انتهاء المهلة بعد تسليم الرسالة يُسجَّل كنتيجة غير معروفة، وليس كإرسال.',
  'set.k.mail.organisationPrivateNetworks.label': 'خوادم SMTP للمؤسسات على الشبكات الخاصة',
  'set.k.mail.organisationPrivateNetworks.help': 'السماح للمؤسسات التي ترسل باسمها باستخدام خادم SMTP على عنوان شبكة خاصة. يمكن للإعداد الافتراضي للتثبيت استخدامه دائمًا.',
  'set.k.sms.provider.label': 'مزوّد الرسائل النصية',
  'set.k.sms.provider.help': 'لم يُختر مزوّد للرسائل النصية بعد. «لا شيء» يسجّل كل رسالة كمحظورة؛ والصندوق الصادر المحلي يكتب ملفات للتطوير.',
  'set.k.whatsapp.provider.label': 'مزوّد واتساب',
  'set.k.whatsapp.provider.help': 'لم يُختر مزوّد لواتساب بعد. «لا شيء» يسجّل كل رسالة كمحظورة؛ والصندوق الصادر المحلي يكتب ملفات للتطوير.',
  'set.k.api.tokenDays.label': 'مدة صلاحية رمز عميل الواجهة البرمجية',
  'set.k.api.tokenDays.help': 'المدة التي يبقى فيها الرمز الصادر حديثًا لعميل الواجهة البرمجية صالحًا.',
  'set.k.webhook.privateNetworks.label': 'خطافات الويب إلى الشبكات الخاصة',
  'set.k.webhook.privateNetworks.help': 'السماح لاشتراكات خطافات الويب بالتسليم إلى عناوين شبكات خاصة.',
  'set.k.webhook.timeoutMs.label': 'مهلة خطاف الويب',
  'set.k.webhook.timeoutMs.help': 'التسليم الذي لا يُجاب عنه في الوقت يُعاد؛ نتيجته غير معروفة وليست نجاحًا أبدًا.',
  'set.k.accessAdapter.privateNetworks.label': 'محوّلات التحكم في الدخول على الشبكات الخاصة',
  'set.k.accessAdapter.privateNetworks.help': 'السماح لمحوّل REST العام للتحكم في الدخول بالوصول إلى وحدات تحكم على عناوين شبكات خاصة.',
  'set.k.calendar.providerMode.label': 'مزوّدو التقويم',
  'set.k.calendar.providerMode.help': 'لا توجد حتى الآن سوى محاكيات للمزوّدين. «لا شيء» يبقي اتصالات التقويم كإعداد فقط.',
  'set.k.calendar.providerTimeoutMs.label': 'مهلة مزوّد التقويم',
  'set.k.calendar.providerTimeoutMs.help': 'نداء المزوّد الذي لا يُجاب في الوقت تكون نتيجته غير معروفة.',
  'set.k.calendar.syncIntervalSeconds.label': 'فاصل مزامنة التقويم',
  'set.k.calendar.syncIntervalSeconds.help': 'عدد مرات تجديد الاشتراكات ومزامنة تقويمات الغرف. القيمة 0 توقف المجدول.',
  'set.k.directory.syncIntervalSeconds.label': 'فاصل مزامنة الدليل',
  'set.k.directory.syncIntervalSeconds.help': 'عدد مرات بدء مزامنات الدليل المستحقة. القيمة 0 توقف المجدول.',
  'set.k.directory.testSampleSize.label': 'عينة اختبار الدليل',
  'set.k.directory.testSampleSize.help': 'عدد المدخلات التي يقرؤها «اختبار الاتصال» بالدليل (تُعرض الأعداد فقط).',
  'set.k.malware.scanner.label': 'فاحص البرمجيات الضارة للملفات المرفوعة',
  'set.k.malware.scanner.help': 'مع «لا شيء» لا تُفحص الملفات المرفوعة، ولا تُقبل ملفات الزوار أو المقاولين إلا كأصل يُرى شخصيًا. يتطلب ClamAV توصيل خدمة الفحص في النشر.',
  'set.k.clamav.connectTimeoutMs.label': 'مهلة اتصال ClamAV',
  'set.k.clamav.connectTimeoutMs.help': 'مدة انتظار قبول الفاحص للاتصال.',
  'set.k.clamav.scanTimeoutMs.label': 'مهلة فحص ClamAV',
  'set.k.clamav.scanTimeoutMs.help': 'الفحص الذي لا يُجاب في الوقت يعني «تعذّر الفحص»، وليس سليمًا أبدًا.',
  'set.k.clamav.maxStreamBytes.label': 'أكبر ملف لـ ClamAV',
  'set.k.clamav.maxStreamBytes.help': 'أبقِها مساوية لقيمة StreamMaxLength لدى الفاحص؛ ولا تقل أبدًا عن أكبر ملف مرفوع (10 ميغابايت).',
  'set.k.clamav.chunkBytes.label': 'حجم الجزء لـ ClamAV',
  'set.k.clamav.chunkBytes.help': 'عدد البايتات المرسلة إلى الفاحص في كل جزء.',
  'set.k.clamav.signatureMaxAgeDays.label': 'تنبيه عمر التواقيع',
  'set.k.clamav.signatureMaxAgeDays.help': 'تنبّه صحة العمليات عندما تكون قاعدة التواقيع أقدم من ذلك.',
  'set.k.ai.providers.label': 'محوّلات الذكاء الاصطناعي المتاحة',
  'set.k.ai.providers.help': 'المحوّلات التي يمكن للمؤسسات اختيارها (وتقرر كل مؤسسة بنفسها استخدام الذكاء الاصطناعي). «لا شيء» متاح دائمًا. تتطلب المحوّلات الخارجية اتفاقية معالجة بيانات أولًا.',
  'set.k.ai.providerTimeoutMs.label': 'مهلة مزوّد الذكاء الاصطناعي',
  'set.k.ai.providerTimeoutMs.help': 'نداء المزوّد الذي لا يُجاب في الوقت يُسجَّل كغير متاح، وليس كإجابة أبدًا.',
  'set.k.ai.anthropicApiKey.label': 'مفتاح Anthropic للتثبيت',
  'set.k.ai.anthropicApiKey.help': 'اختياري. بدونه يخزّن مسؤول إعدادات الذكاء الاصطناعي في كل مؤسسة مفتاحه المختوم.',
  'set.k.ai.anthropicModel.label': 'نموذج Anthropic',
  'set.k.ai.anthropicModel.help': 'معرّف النموذج المستخدم لطلبات الذكاء الاصطناعي الخارجية.',
  'set.k.ai.anthropicEffort.label': 'جهد Anthropic',
  'set.k.ai.anthropicEffort.help': 'مستوى جهد الاستدلال المطلوب من النموذج.',
  'set.k.ai.anthropicMaxTokens.label': 'حد إجابة Anthropic',
  'set.k.ai.anthropicMaxTokens.help': 'الحد الأقصى للرموز في إجابة واحدة.',
  'set.k.ai.anthropicMaxRetries.label': 'إعادات محاولة Anthropic',
  'set.k.ai.anthropicMaxRetries.help': 'إعادة المحاولة للأخطاء القابلة لذلك فقط (حد المعدّل وأخطاء الخادم والاتصال)، ضمن المهلة.',
  'set.k.ai.anthropicFallbacks.label': 'بديل الرفض لدى Anthropic',
  'set.k.ai.anthropicFallbacks.help': 'السماح للمزوّد بإعادة الطلب المرفوض عبر البديل من جهة الخادم (المزوّد نفسه).',
  'set.k.ai.anthropicInferenceGeo.label': 'منطقة الاستدلال لدى Anthropic',
  'set.k.ai.anthropicInferenceGeo.help': 'تلميح منطقة اختياري يُرسل مع الطلبات الخارجية. فارغ = الافتراضي لدى المزوّد. لا يُبنى عليه أي ادعاء بالإقامة.',
  'set.k.worker.pollMs.label': 'فاصل استطلاع العامل',
  'set.k.worker.pollMs.help': 'مدة انتظار العامل عندما يكون صندوق الصادر فارغًا.',
  'set.k.worker.batchSize.label': 'حجم دفعة العامل',
  'set.k.worker.batchSize.help': 'عدد أحداث صندوق الصادر المحجوزة في كل دفعة.',
  'set.k.worker.leaseMs.label': 'مدة حجز العامل',
  'set.k.worker.leaseMs.help': 'المدة التي يبقى فيها الحدث المحجوز قبل أن يتمكن عامل آخر من أخذه.',
  'set.k.worker.maxAttempts.label': 'محاولات العامل',
  'set.k.worker.maxAttempts.help': 'عدد المحاولات قبل نقل الحدث إلى قائمة المعطّلة ليعالجه مشغّل.',
  'set.k.worker.sweepMs.label': 'فاصل الجولات الدورية للعامل',
  'set.k.worker.sweepMs.help': 'عدد مرات تشغيل الجولات الدورية (انتهاء الزيارات وتجاوز المدة والتذكيرات والموافقات والتقارير).',
  'set.k.worker.accessEventPollMs.label': 'فاصل استطلاع أحداث الدخول',
  'set.k.worker.accessEventPollMs.help': 'أقل مدة بين استطلاعين لأحداث الدخول من موصل واحد. القيمة 0 توقف الاستطلاع.',
  'set.k.idempotency.retentionHours.label': 'مدة الاحتفاظ بسجلات منع التكرار',
  'set.k.idempotency.retentionHours.help': 'المدة التي يعيد فيها الأمر المكرر بالمفتاح نفسه النتيجة الأولى.',
  'set.k.privacy.plannerIntervalSeconds.label': 'فاصل تخطيط الاحتفاظ',
  'set.k.privacy.plannerIntervalSeconds.help': 'عدد مرات تخطيط عمليات الحذف المستحقة. التخطيط لا ينفّذ حذفًا أبدًا. القيمة 0 توقفه.',
  'set.k.api.rateLimitPerMinute.label': 'الحد الافتراضي لعميل الواجهة البرمجية',
  'set.k.api.rateLimitPerMinute.help': 'عدد الطلبات في الدقيقة الذي يحصل عليه عميل جديد للواجهة البرمجية. يحتفظ العملاء الحاليون بحدودهم.',
  'set.k.reception.lookupPerMinute.label': 'عمليات البحث في الاستقبال',
  'set.k.reception.lookupPerMinute.help': 'عمليات البحث في الاستقبال لكل مستخدم في الدقيقة.',
  'set.k.reception.sensitiveLookupPerMinute.label': 'عمليات البحث الحساسة في الاستقبال',
  'set.k.reception.sensitiveLookupPerMinute.help': 'عمليات البحث برقم اللوحة أو رقم الهوية لكل مستخدم في الدقيقة.',
  'set.k.exports.ttlHours.label': 'نافذة تنزيل الملفات المصدّرة',
  'set.k.exports.ttlHours.help': 'عدد الساعات التي يبقى فيها ملف التصدير متاحًا للتنزيل قبل إزالته (يمكن للمؤسسة ضبط نافذة أقصر).',
  'set.k.pdf.threads.label': 'عمليات إنشاء PDF المتوازية',
  'set.k.pdf.threads.help': 'عدد ملفات PDF التي تُنشأ معًا في كل عملية.',
  'set.k.pdf.timeoutMs.label': 'مهلة إنشاء PDF',
  'set.k.pdf.timeoutMs.help': 'الإنشاء الذي يستغرق أطول من ذلك يفشل؛ ولا يُحتفظ بأي جزء منه.',
  'set.k.imports.maxBytes.label': 'أكبر ملف استيراد',
  'set.k.imports.maxBytes.help': 'أكبر جدول بيانات يقبله استيراد السجلات وقوائم الزيارات.',
  'set.k.imports.maxRows.label': 'صفوف الاستيراد',
  'set.k.imports.maxRows.help': 'عدد الصفوف المقبولة في كل استيراد للسجلات.',
  'set.k.imports.maxColumns.label': 'أعمدة الاستيراد',
  'set.k.imports.maxColumns.help': 'عدد الأعمدة المقبولة في كل ملف استيراد.',
  'set.k.imports.maxUncompressedBytes.label': 'الحجم بعد فك الضغط',
  'set.k.imports.maxUncompressedBytes.help': 'أكبر حجم لجدول البيانات بعد فك ضغطه (حماية من الملفات المضغوطة المفخخة).',
  'set.k.imports.chunkRows.label': 'جزء الاستيراد',
  'set.k.imports.chunkRows.help': 'عدد الصفوف المطبّقة في كل خطوة عند استيراد الصفوف الصالحة فقط.',
  'set.k.imports.rosterMaxRows.label': 'صفوف قائمة الزيارة',
  'set.k.imports.rosterMaxRows.help': 'عدد الصفوف المقبولة في كل قائمة زيارة.',
  'set.k.devices.staleSeconds.label': 'نبض الجهاز',
  'set.k.devices.staleSeconds.help': 'عدد الثواني دون نبض قبل أن يظهر الجهاز كمتقادم.',
  'set.k.edge.commandTtlSeconds.label': 'مدة صلاحية أوامر الطرف',
  'set.k.edge.commandTtlSeconds.help': 'عدد الثواني التي يبقى فيها أمر وكيل الطرف الموقّع صالحًا.',
};
